import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'トップ', path: '/' },
  { label: '協会について', path: '/about' },
  { label: '活動内容', path: '/activities' },
  { label: '入会案内', path: '/membership' },
  { label: '協賛', path: '/sponsorship' },
  { label: 'お知らせ', path: '/news' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const bgClass = isHome
    ? scrolled
      ? 'bg-forest-800 shadow-sm'
      : 'bg-transparent'
    : 'bg-forest-800';

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${bgClass}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer whitespace-nowrap flex-shrink-0">
            <img
              src="/images/OMFES_letterhed_touka2.png"
              alt="OMFES ロゴ"
              className="h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-0">
            {navLinks.map((link, i) => (
              <div key={link.path} className="flex items-center">
                {i > 0 && <span className="text-cream-500/30 text-xs select-none mx-1">|</span>}
                <Link
                  to={link.path}
                  className={`px-4 py-1 text-sm font-serif tracking-widest transition-colors duration-200 whitespace-nowrap cursor-pointer
                    ${location.pathname === link.path
                      ? 'text-gold-400'
                      : 'text-cream-300 hover:text-cream-100'
                    }`}
                >
                  {link.label}
                </Link>
              </div>
            ))}
            <Link
              to="/contact"
              className="ml-6 px-5 py-2 border border-cream-400/60 text-cream-300 text-sm font-serif tracking-widest rounded hover:bg-cream-200/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </nav>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <span className={`block w-6 h-px bg-cream-200 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-px bg-cream-200 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-px bg-cream-200 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden bg-forest-800 border-t border-forest-700 transition-all duration-300 overflow-hidden ${menuOpen ? 'max-h-screen' : 'max-h-0'}`}>
        <nav className="px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`py-3 text-sm font-serif tracking-widest border-b border-forest-700/50 cursor-pointer whitespace-nowrap
                ${location.pathname === link.path ? 'text-gold-400' : 'text-cream-300'}`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="mt-3 py-3 text-center border border-cream-400/50 text-cream-300 text-sm font-serif tracking-widest rounded cursor-pointer whitespace-nowrap"
          >
            お問い合わせ
          </Link>
        </nav>
      </div>
    </header>
  );
}
